module.exports = __webpack_public_path__ + "static/media/discount_image.91037cff.png";